
import React from "react";

const AboutSection: React.FC = () => {
  return (
    <section className="section-container relative overflow-hidden" id="about">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-radial from-white/5 to-transparent opacity-50" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(255,255,255,0.02)_0%,_transparent_50%)] animate-[pulse_4s_ease-in-out_infinite]" />
      </div>
      
      <div className="max-w-4xl mx-auto relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center scroll-reveal">
          Isto aqui não é pra qualquer um.
        </h2>
        <div className="text-xl space-y-8">
          <p className="scroll-reveal">Chega de sobreviver no automático.</p>
          <p className="scroll-reveal">A maioria das pessoas está viva no documento — mas morta na ação.</p>
          <p className="scroll-reveal">
            A ESCAPE CLUB é pra quem quer acordar de verdade e construir disciplina, saúde e liberdade interna.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
